import dataService from "../../api";
import { startLoading, stopLoading,showNotification, serverErrorMessage, showAlert, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        suppliers: [ ],
        supplier: {},
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.suppliers.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.suppliers = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.supplier = viewData,
        add: (state, addedData) => state.suppliers.unshift(addedData),
        edit: (state, { index, r }) => state.suppliers.splice(index, 1, r),
        delete: (state, index) => state.suppliers.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                    const response = await dataService.suppliers.getAll(paramsString);
                    stopLoading()
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
        
                commit('SET_ITEMS', response.data.suppliers);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
      
    async getDetails({ commit }, id) {
        try {
            commit("SET_ITEM", {});
            startLoading()
            const response = await dataService.suppliers.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
            commit("SET_ITEM", response.data.supplier);
        
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.suppliers.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.supplier);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
  
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.suppliers.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.supplier);
        
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.suppliers.edit(id,payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
          
            const index = getters.index(id);
            commit("edit", { index, r: response.data.supplier });

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.suppliers.delete(id);

            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    },
};
